angular.module('app-ui-switch-user').directive(
    'appUiSwitchUserFindSwitchUser',
    [
        'profileRepository',
        'rcmSwitchUserAdminService',
        function (
            profileRepository,
            rcmSwitchUserAdminService
        ) {

            var link = function (scope) {

                scope.propSearchLabel = 'Lookup RCN';
                scope.propSearchProperties = [
                    {
                        name: 'name',
                        label: 'Search by last name (optional):',
                        placeholder: 'last name',
                    },
                ];

                scope.propResults = [];
                scope.propResultsDisplay = false;
                scope.propModalTitle = 'Search results';
                scope.propModalBody = 'Click to switch to user';
                scope.propSearchResultProperties = [
                    {
                        name: 'name',
                        label: 'Name',
                    },
                    {
                        name: 'email',
                        label: 'Email',
                    },
                    {
                        name: 'rcn',
                        label: 'RCN',
                    },
                ];

                scope.propShowSwitchToUserNameField = true;
                scope.propSwitchToUserName = '';
                scope.propSwitchToUserNamePlaceholder = 'RCN or username';
                scope.propSwitchToUserNameButtonLabel = 'Switch to User';
                scope.propSwitchBackButtonLabel = 'End Impersonation';
                scope.propSwitchUserInfoContentPrefix = 'Impersonating:';

                /**
                 *
                 */
                scope.showSearchResults = function () {
                    scope.propResultsDisplay = true;
                };

                /**
                 *
                 */
                scope.hideSearchResults = function () {
                    scope.propResultsDisplay = false;
                };

                /**
                 *
                 * @param {string} search
                 * @param {*} searchId
                 */
                scope.handleSearchSubmit = function (search, searchId) {

                    scope.hideSearchResults();

                    var params = {};
                    for (var key in search) {
                        params['filter[where][' + key + ']'] = search[key];
                    }

                    profileRepository.find(params).then(
                        function (response) {
                            scope.propResults = response.data;
                            scope.showSearchResults();
                            scope.$apply();
                        }
                    ).catch(
                        function (response) {
                            scope.propResults = [];
                            scope.hideSearchResults();
                            scope.$apply();
                        }
                    );
                };

                /**
                 *
                 * @param {*} userProfile
                 * @param {*} searchId
                 */
                scope.handleSearchResultSelect = function (userProfile, searchId) {
                    scope.propSwitchToUserName = userProfile.rcn;
                    scope.hideSearchResults();
                    // defined by rcmSwitchUserAdminService.link()
                    scope.switchTo();
                };

                var init = function () {
                    rcmSwitchUserAdminService.link(scope);
                };

                init();
            };

            return {
                link: link,
                scope: {
                    propShow: '=show',
                    propSearchId: '=searchId', // Search unique id
                    propLoading: '=loading', // bool
                },
                template: '' +
                '<div class="switch-user-find-switch-user panel panel-default" ng-show="propShow">' +
                '   <div class="panel-heading">' +
                '            <h3 class="panel-title">Switch User</h3>' +
                '   </div>' +
                '   <div class="panel-body">' +
                '       <div>' +
                '           <app-ui-profile-user-profile-search' +
                '               class=""' +
                '               search-id="propSearchId"' +
                '               loading="propLoading"' +
                '               on-search-submit="handleSearchSubmit"' +
                '               search-properties="propSearchProperties"' +
                '               label="propSearchLabel"' +
                '           >' +
                '           </app-ui-profile-user-profile-search>' +
                '           <app-ui-profile-user-profile-search-results-modal' +
                '               search-id="propSearchId"' +
                '               loading="propLoading"' +
                '               results="propResults"' +
                '               on-result-select="handleSearchResultSelect"' +
                '               search-properties="propSearchResultProperties"' +
                '               display="propResultsDisplay"' +
                '               on-close="hideSearchResults"' +
                '               modal-title="propModalTitle"' +
                '               modal-body="propModalBody"' +
                '           >' +
                '           </app-ui-profile-user-profile-search-results-modal>' +
                '       </div>' +
                '       <div>' +
                '       <rcm-switch-user-switch-to-user-simple' +
                '               loading="loading"' +
                '               is-su="isSu"' +
                '               impersonated-user="impersonatedUser"' +
                '               switch-back-method="switchBackMethod"' +
                '               show-switch-to-user-name-field="propShowSwitchToUserNameField"' +
                '               switch-to-user-name="propSwitchToUserName"' +
                '               switch-to-user-name-placeholder="propSwitchToUserNamePlaceholder"' +
                '               switch-to-user-name-button-label="propSwitchToUserNameButtonLabel"' +
                '               switch-back-button-label="propSwitchBackButtonLabel"' +
                '               su-user-password="suUserPassword"' +
                '               switch-user-info-content-prefix="propSwitchUserInfoContentPrefix"' +
                '               message="message"' +
                '               on-switch-to="switchTo"' +
                '               on-switch-back="switchBack"' +
                '           >rcm-switch-user-switch-to-user-simple' +
                '           </rcm-switch-user-switch-to-user-simple>' +
                '       </div>' +
                '   </div>' +
                '</div>',
            };
        },
    ]
);
/* EXAMPLE
 <div app-ui-switch-user-find-switch-user=""
 show="true"
 search-id="'SwitchUser'"
 loading="false"
 >
 </div>
 */
